import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./CustomProducts.css";

import arrowRightIconWhite from "../../../../Assets/Icons/arrow-right-icon-white.svg";
import customSoftwareSample1 from "../../../../Assets/Images/custom-software-sample1.svg";
import customSoftwareSample2 from "../../../../Assets/Images/custom-software-sample2.svg";
import customSoftwareSample3 from "../../../../Assets/Images/custom-software-sample3.svg";
import customSoftwareSample4 from "../../../../Assets/Images/custom-software-sample4.svg";

import customSoftwareSample5 from "../../../../Assets/Images/Paragon.jpg";

const CustomProducts = () => {
  const products = [
    {
      id: 1,
      title: "Paragon Hotel and Resort",
      client: "Client",
      categories: ["Windows Form Application"],
      year: "2023",
      description:
        "As the number of operations increased, managing reservations, billing and staff across multiple systems became a daily challenge. We helped Paragon bring everything into one Windows-based platform, making the hotel operations smoother without necessitating changes to the way their operations team works.",
      images: [customSoftwareSample5, customSoftwareSample2],
    },
    {
      id: 2,
      title: "GO5050",
      client: "Client",
      categories: ["GO5050 Social Media"],
      year: "2022",
      description:
        "GO5050 required a high technical foundation prior to growth. We developed a responsive social platform with the help of modern architecture, keeping in mind performance, clean structure, and scalability as the engagement of users grew.",
      images: [customSoftwareSample3, customSoftwareSample4],
    },
  ];

  return (
    <section id="samples" className="custom-products">
      <div className="custom-products__header">
        <h2 className="custom-products__title">Proof That The Work Holds Up</h2>
        <Link to="/contact-us/build-business">
          <button className="custom-products__button">
            View Our Work
            <img
              src={arrowRightIconWhite}
              alt="arrow right icon"
              className="arrow-icon"
            />
          </button>
        </Link>
      </div>

      <div className="custom-products__grid">
        {products.map((product) => (
          <ProductItem key={product.id} product={product} />
        ))}
      </div>
    </section>
  );
};

const ProductItem = ({ product }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalImages = product.images.length;

  useEffect(() => {
    if (totalImages <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % totalImages);
    }, 3000);

    return () => clearInterval(interval);
  }, [totalImages]);

  return (
    <div className="custom-products__item">
      <div className="custom-products__content">
        <div className="custom-products__info">
          <h3 className="custom-products__product-title">{product.title}</h3>
          <p className="custom-products__client">{product.client}</p>
          <div className="custom-products__divider"></div>

          {product.categories.length > 0 && (
            <>
              <h3 className="custom-products__category-value">
                {product.categories[0]}
              </h3>
              <p className="custom-products__category-label">Categories</p>
              <div className="custom-products__divider"></div>
            </>
          )}

          <h4 className="custom-products__year">{product.year}</h4>
          <p className="custom-products__date-label">Project Date</p>
          <div className="custom-products__divider"></div>
        </div>

        <p className="custom-products__description">{product.description}</p>
      </div>

      <div className="custom-products__image-wrapper">
        <div className="custom-products__image-container">
          <img
            src={product.images[currentIndex]}
            alt={`${product.title} - view ${currentIndex + 1}`}
            className="custom-products__image"
          />
        </div>
        {totalImages > 1 && (
          <div className="custom-products__progress-indicator">
            <div
              className={`custom-products__progress-bar ${
                currentIndex === 0
                  ? "custom-products__progress-bar--active"
                  : ""
              }`}
            ></div>
            <div
              className={`custom-products__progress-bar ${
                currentIndex === 1
                  ? "custom-products__progress-bar--active"
                  : ""
              }`}
            ></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomProducts;
